import { render, staticRenderFns } from "./MyContribution.vue?vue&type=template&id=4d60a4b0&scoped=true&"
import script from "./MyContribution.vue?vue&type=script&lang=js&"
export * from "./MyContribution.vue?vue&type=script&lang=js&"
import style0 from "./MyContribution.vue?vue&type=style&index=0&id=4d60a4b0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d60a4b0",
  null
  
)

export default component.exports